// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__ViY4B","content":"Chat_content__GrZNM"};